export enum RequesterMethodEnum {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  PATCH = 'PATCH',
}

export type RequesterServiceModel = {
  method: RequesterMethodEnum;
  endpoint: string;
  timeout?: number;
  attempt?: number;
};

export type RequesterResponseModel = {
  success: boolean;
  status?: number;
  error: any;
  data: any;
};

export type RequesterOptionsModel = {
  data?: any;
  headers?: any;
};
